import {
  formatUrl,
  urls,
  formatJsCode,
  formatVastUrl,
  formatEventPixelUrl,
} from 'utils/creative/formatUrlsUtils/utils';

/**
 * Функция форматирования ссылки в зависимости от типа ссылки
 * @param name Получаем название поля ссылки
 * @param value Получаем значение
 * @returns Отформатированная ссылка в зависимости от поля
 */
export function getCurrentUrlFormat(
  // inputAttributes: inputAttributesType,
  name: string,
  value: string,
): string {
  switch (name) {
    case 'link':
      return formatUrl(String(value), urls, name);
    case 'click_audit_pixel':
      return formatUrl(String(value), urls, name);
    case 'pixel':
      return formatUrl(String(value), urls, name);
    case 'pixel_additional':
      return formatUrl(String(value), urls, name);
    case 'pixel_additional2':
      return formatUrl(String(value), urls, name);
    case 'js_code_audit':
      return formatJsCode(String(value), name);
    case 'data.vast_url':
      return formatVastUrl(String(value), name);
    case 'data.audit.click':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.close':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.collapse':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.exitfs':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.expand':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.fullscreen':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.mute':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.pause':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.resume':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.rewind':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.show':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.show2':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.show3':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.skip':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.sprogresshow':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.unmute':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.view_0':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.view_25':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.view_50':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.view_75':
      return formatEventPixelUrl(String(value), name);
    case 'data.audit.view_100':
      return formatEventPixelUrl(String(value), name);
    default:
      return '';
  }
}
